import { IModel, IViolation } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { DataFlowExpression } from './dataflowexpression';
import { Owned } from '../base/named';
import { IDataFlowArguments, convertColumnRefToDataFlowColumn, convertParametersToArguments, convertCacheSinksToArguments } from './dataflow-expression-utilities';
import { DataFlowExpressionFunctions } from './dataflow-expression-functions';
import { ColumnReference } from '../dataset/columnReference';
import { OwnedSet } from 'shell-models-lib';
import { DataFlowParameter } from './dataflow-parameter';
import { updateIdentifiers, asyncUpdateIdentifiers } from './dataflow-expression-update-identifiers';
import { Transformation } from './transformation';
import { GlobalVariables } from 'app/services/globals';
import { DataFlowSink } from './dataflow-sink';

export interface ISortableTransformation {
    sortExpressions: SortExpression[];
}

@Metamodel.model({
    name: 'sortExpression'
})
export class SortExpression extends Owned {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.Order
    })
    public ascending: boolean;

    @Metamodel.attribute({
        display: stringResources.DataFlowNullsFirstLabel
    })
    public nullsFirst: boolean;

    @Metamodel.attribute({
        display: stringResources.Expression
    })
    public dataFlowExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    public static validateExpressions(transformation: ISortableTransformation): IViolation[] {
        const violations: IViolation[] = [];
        if (transformation.sortExpressions.find((expression) => !expression.dataFlowExpression.expression)) {
            violations.push({
                context: transformation,
                message: () => stringResources.SortNoExpressionDescription
            });
        }
        return violations;
    }

    public static updateSortExpressionIdentifiers(sortExpressions: SortExpression[], inputColumns: ColumnReference[],
        parameters: OwnedSet<DataFlowParameter>, cacheSinks: OwnedSet<DataFlowSink>, owningTransformation: Transformation): void {
        const availableArguments: IDataFlowArguments = {
            dataFlowColumns: convertColumnRefToDataFlowColumn(inputColumns),
            dataFlowFunctions: DataFlowExpressionFunctions.ALL_FUNCTIONS,
            dataFlowParameters: convertParametersToArguments(parameters),
            dataFlowTransientColumns: [],
            dataFlowCacheSinks: convertCacheSinksToArguments(cacheSinks)
        };
        sortExpressions.forEach((sortExpression) => {
            if (sortExpression.dataFlowExpression) {
                if (GlobalVariables.validateDataFlowAPI) {
                    asyncUpdateIdentifiers(availableArguments, sortExpression.dataFlowExpression, owningTransformation);
                } else {
                    updateIdentifiers(availableArguments, sortExpression.dataFlowExpression);
                }
            }
        });
    }
}
